import { connect } from "react-redux";
import SiteInfoChecklist from "./siteInfoCheckList";
import { bindActionCreators } from "redux";
import { getSiteInfo } from "services/redux/installation/siteInformationCheckList/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { postSiteInspection } from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
  siteInfoData: state.siteInfoReducer.siteInfoData,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteInfo,
      getGateInfo,
      documentUploadUrl,
      postSiteInspection,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteInfoChecklist);
